import axiosInstance from "./axiosConfig";


export function getRequest(URL, headers = null) {
  return axiosInstance.get(`/${URL}`, headers).then(response => response);
}


export function postRequest(URL, payload, headers = null) {
  return axiosInstance.post(`${URL}`, payload, headers)
    .then(response => response)
    .catch(error => {
      if (error.response && error.response.status === 400) {
        return Promise.reject( error.response.data)
      } else {
        return error.response;
      }
    });
}

export function patchRequest(URL, payload, headers = {}) {
  return axiosInstance
    .patch(`/${URL}`, payload, headers)
    .then(response => response)
    .catch(error => {
      throw error; // Don't just console.log it — rethrow to catch in caller
    });
}


export function deleteRequest(URL, headers = null) {
  return axiosInstance.delete(`/${URL}`, headers).then(response => response)
  .catch((error)=> console.log(error));
}
